module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back001.466af5f2.webp";